import { useState, useEffect } from 'react';
import { OptionHistoryResponse, OptionHistoryInterval } from '../types/StockData';

export const useOptionHistoryData = (optionContract: string, interval: OptionHistoryInterval) => {
  const [data, setData] = useState<OptionHistoryResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    if (!optionContract || optionContract.trim() === '') {
      setData(null);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(
        `https://tradewithaiapi20250728175655.azurewebsites.net/api/whales/optionhistory/${optionContract}/${interval}`
      );
      
      if (!response.ok) {
        throw new Error(`Failed to fetch option history data: ${response.statusText}`);
      }

      const result: OptionHistoryResponse = await response.json();
      setData(result);
    } catch (err) {
      console.error('Error fetching option history data:', err);
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [optionContract, interval]);

  const refetch = () => {
    fetchData();
  };

  return { data, loading, error, refetch };
};
